import server from "@/api/server";

async function addValue(value, fieldId) {
  let res = server.post('agent/management/profile-field/add-value', { value, field_id: fieldId });
  return res;
}

async function getPersons(appId) {
  let res = await server.post('agent/management/app/get-persons', { id: appId });
  return res;
}

async function getTasksWithHistory(appId) {
  let res = await server.post('agent/management/app/get-tasks-with-history', { id: appId });
  return res;
}

export { addValue, getPersons, getTasksWithHistory }
